
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    usuario:{
      id:'',
      name:'',
      identificador:'',
      email:'',
      password:''
              },
    drawer:false,
    items:[ 

         {text:'Empresa',to:'/data_empresa',icon:'mdi-account-circle'},
         {text:'Vendedor',to:'/vendedor',icon:'mdi-account-circle'},
          {text:'Categoria',to:'/categoria',icon:'mdi-account-circle'},
           {text:'Proveedor',to:'/proveedor',icon:'mdi-account-circle'},
           {text:'Producto',to:'/producto',icon:'mdi-account-circle'},
           
      {text:'Imagenes',to:'/imagenes_base',icon:'mdi-google'},
	 {text:'Perfiles',to:'/principal',icon:'mdi-account-circle'},
   {text:'Opciones',to:'/opcion',icon:'mdi-account-circle'},
      {text:'Cerrar Sessión',to:'/logout',icon:'mdi-account-circle'},
    ],
    itemsUsuario:[ 
    
      {text:'Usuario',to:'/data_user',icon:'mdi-account-circle'},
    //  {text:'Registrar Producto',to:'/register_producto_user',icon:'mdi-storefront'},
    // 
    //  {text:'Registro de Comprobantes',to:'/registro_comprobantes',icon:'mdi-account-circle'},
      // {text:'Login',to:'/login',icon:'mdi-account-circle'},
         {text:'About',to:'/about',icon:'mdi-account-circle'},
    
       ] 

       ,
    itemsStore:[ 
    
      // {text:'Home',to:'/store/all',icon:'mdi-home-circle'},
   //   {text:'Vendedor',to:'/perfil/magzoa',icon:'mdi-account-circle'},
    // 
    //  {text:'Registro de Comprobantes',to:'/registro_comprobantes',icon:'mdi-account-circle'},
      // {text:'Login',to:'/login',icon:'mdi-account-circle'},
    //     {text:'About',to:'/about',icon:'mdi-account-circle'},
    
       ] 
  },
  getters:{
    links:(state)=>{
      return state.items
    },
    linksUsuario:(state)=>{
      return state.itemsUsuario
    },
    linksStore:(state)=>{
      return state.itemsStore
    }

  },
  mutations: {
    setDrawer:(state,payload)=>(state.drawer=payload),
    toggleDrawer:state=>(state.drawer=!state.drawer),
    setUsuario(state, usuario) {
      state.usuario = usuario;
    }
  },
  actions: {
  },
  modules: { 
   
  }
})


